<template>
  <div class="invoice-details-section-header">
    <div class="text-h4 mt-8">{{ title }}</div>
    <v-divider class="my-2" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InvoiceDetailsSection',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped></style>
